import * as React from "react";
import "../../../assets/sass/widgets/datePickerWidget.scss";
import Calendar from "react-calendar";
import onClickOutside from "react-onclickoutside";
// import previousIcon from "../../../assets/images/chevron-left-1.svg";
// import nextIcon from "../../../assets/images/chevron-right-1.svg";
import MaskedInput from "react-text-mask";
import { dateFormatter, handleEnter, imagePathurl, dateTimeFormatter } from "../../utils/utils";
import 'react-calendar/dist/Calendar.css';
class DatePicker extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            openCalendar: false,
            dateValue: props.selectedValue || "",
        };
        this.inputBoxChange = this.inputBoxChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidUpdate(prevProps) {
        if(prevProps.selectedValue !== this.props.selectedValue){
            this.setState({
                dateValue: this.props.selectedValue || "",
            });
        }
    }
    // componentDidMount() {
    //     document.body.addEventListener("click", this.handleClickOutside);
    // }

    // componentWillUnmount() {
    //     document.body.removeEventListener("click", this.handleClickOutside);
    // }
    handleClickOutside(evt) {
        this.setState({
            openCalendar: false,
        });
    }
    customDateFormatter = (date) => {
        const d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
        const format = (value) => (value.length < 2 ? "0" + value : value);
        return [format(month), format(day), year].join("");
    };
    calendarToggle = (e) => {
        e.stopPropagation();
        if (!this.props.disabled) {
            this.setState({
                openCalendar: !this.state.openCalendar,
            });
        }
    };
    handleEnter = (e) => {
        if (e.keyCode === 13) {
            this.calendarToggle(e);
        } else if (e.keyCode == 9 || e.keyCode == 27) {
            this.setState({
                openCalendar: false,
            });
        }
    };
    async inputBoxChange(e) {
        const inputValue = e.target.value;
        if (inputValue === "") {
            this.setState({
                    dateValue: "",
                    openCalendar: false,
                },
                () => {
                    this.props.onChange(inputValue);
                }
            );
            return;
        }
        if (!isNaN(new Date(inputValue).getTime())) {
            this.setState(
                {
                    dateValue: inputValue,
                    openCalendar: false,
                },
                () => {
                    this.props.onChange(inputValue);
                }
            );
        }
    }
    async onChange(date) {
        this.setState(
            {
                dateValue: dateFormatter(date),
                openCalendar: !this.state.openCalendar,
            },
            () => {
                this.props.onChange(this.state.dateValue);
            }
        );
    }
    blurCheck = () => {
        this.setState({
            openCalender: false,
        });
    };
    render() {
        const getimagePath = imagePathurl();
        const { placeHolder, id, fromDate, maxDays, disabled, isError } = this.props;
        let disableMinDate = null;
        let disableMaxDate = new Date();
        if (fromDate) {
            disableMinDate = fromDate;
            disableMaxDate = new Date(fromDate.getTime() + maxDays * 24 * 60 * 60 * 1000);
            if (disableMaxDate.getTime() > new Date().getTime()) {
                disableMaxDate = new Date();
            }
        }
        return (
            <div className="inputbox-rectangle date-input">
                <div className="calendar-container">
                    <div>
                        <div className="input-container input-container-form" onKeyDown={this.handleEnter}>
                            <MaskedInput
                                id={id}
                                type="text"
                                placeholder={placeHolder}
                                tabIndex={0}
                                onKeyPress={handleEnter}
                                className={`date-textbox ${isError ? "date-textbox-error" : ""}`}
                                mask={
                                    this.state.dateValue
                                        ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
                                        : []
                                }
                                value={
                                    this.state.dateValue.length !== 10
                                        ? this.customDateFormatter(this.state.dateValue)
                                        : dateFormatter(this.state.dateValue)
                                }
                                onChange={this.inputBoxChange}
                                onBlur={this.blurCheck}
                                onClick={this.calendarToggle}
                                disabled={disabled}
                            />
                            <img
                                src={`${getimagePath}calendar.png`}
                                className="calendar-icon"
                                onClick={this.calendarToggle}
                            />
                        </div>
                        {this.state.openCalendar ? (
                            <div
                                className="calender-main-container"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <Calendar
                                    onChange={this.onChange}
                                    value={
                                        !isNaN(new Date(this.state.dateValue).getTime())
                                            ? new Date(this.state.dateValue)
                                            : new Date()
                                    }
                                    minDate={disableMinDate}
                                    maxDate={disableMaxDate}
                                    prevLabel={<img src={`${getimagePath}chevron-left-1.svg`} alt="PrevButton"></img>}
                                    nextLabel={<img src={`${getimagePath}chevron-right-1.svg`} alt="NextButton"></img>}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default onClickOutside(DatePicker);
